export enum FamilyStatus {
  NotSelected = 0,
  Single = 1,
  Married = 2,
}
